var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M6.5 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4.5 20V10q0-.825.588-1.412A1.93 1.93 0 0 1 6.5 8h9V6q0-1.25-.875-2.125A2.9 2.9 0 0 0 12.5 3q-1.05 0-1.838.638T9.6 5.225a1 1 0 0 1-.413.563A1.2 1.2 0 0 1 8.5 6a1 1 0 0 1-.712-.275.67.67 0 0 1-.213-.65q.35-1.725 1.725-2.9T12.5 1q2.075 0 3.538 1.462T17.5 6v2h1q.825 0 1.413.588T20.5 10v10q0 .825-.587 1.413A1.92 1.92 0 0 1 18.5 22zm0-2h12V10h-12zm6-3q.825 0 1.413-.587A1.92 1.92 0 0 0 14.5 15q0-.825-.587-1.412A1.93 1.93 0 0 0 12.5 13q-.825 0-1.412.588A1.93 1.93 0 0 0 10.5 15q0 .825.588 1.413T12.5 17"
  })));
};
export default SvgLock;